import https from '@sg/utils/httpC';

// Dashboard APIs
export const getGameList = (): Promise<any> => https({
  url: '/api/v2/dashboard/mgmt/game_list',
  method: 'post',
});

export const getGameMetricList = (params: { game_code: string }): Promise<any> => https({
  url: '/api/v2/dashboard/mgmt/game_metric_list_v2',
  method: 'post',
  data: params,
  rawData: true,
});

export const getDashboardRainbowInfo = (params: {
  game_code: string;
  folder: string;
}): Promise<any> => {
  return https({
    url: '/api/v1/dashboard/rainbow/info',
    method: 'post',
    data: params,
    rawData: true,
  }).then((response: any) => {
    // formatData: Extract rows from response data, similar to dashboardRequest pattern
    const { rows = [] } = response?.data || {};
    return rows;
  });
};

// Old API - commented out but kept for reference
// export const getDashboardCardMetrics = (payload: any): Promise<any> => https({
//   url: '/api/v2/dashboard/mgmt/overview/card_metrics',
//   method: 'post',
//   data: payload,
//   rawData: true,
// });

// New API - includes trend_metrics parameter (Daily)
export const getDashboardCardMetrics = (payload: {
  game_code: string;
  period: string;
  start_time: string;
  end_time: string;
  metrics: string[];
  trend_metrics: string[]; // Required - must be provided at code level
}): Promise<any> => {
  return https({
    url: '/api/v2/dashboard/mgmt/overview/daily/card_metrics',
    method: 'post',
    data: payload,
    rawData: true,
  });
};

// Weekly card metrics API
export const getWeeklyCardMetrics = (payload: {
  game_code: string;
  period: 'weekly';
  start_time: string; // Monday date (cannot be current week)
  end_time: string; // Sunday date (cannot be current week)
  metrics: string[];
  trend_metrics: string[];
}): Promise<any> => {
  return https({
    url: '/api/v2/dashboard/mgmt/overview/weekly/card_metrics',
    method: 'post',
    data: payload,
    rawData: true,
  });
};

// Monthly card metrics API
export const getMonthlyCardMetrics = (payload: {
  game_code: string;
  period: 'monthly';
  start_time: string; // First day of month (cannot be current month)
  end_time: string; // Last day of month (cannot be current month)
  metrics: string[];
  trend_metrics: string[];
}): Promise<any> => {
  return https({
    url: '/api/v2/dashboard/mgmt/overview/monthly/card_metrics',
    method: 'post',
    data: payload,
    rawData: true,
  });
};
